module.exports = __webpack_public_path__ + "img/ProfileBG.7b2e1d06.svg";